module.exports = __webpack_public_path__ + "static/media/RHE58M.5cbb781b.jpg";